/* eslint-disable react-hooks/exhaustive-deps */
import { Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import AppShell from "./components/AppShell";
import FilesPage from "./pages/FilesPage";
import DrivePage from "./pages/DrivePage";
import StudioPage from "./pages/StudioPage";
import CalendarPage from "./pages/CalendarPage";
import SearchPage from "./pages/SearchPage";
import GroupsPage from "./pages/GroupsPage";
import SettingsPage from "./pages/SettingsPage";
import LoginPage from "./pages/LoginPage";
import AccountPage from "./pages/AccountPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ConfirmEmailChangePage from "./pages/ConfirmEmailChangePage";

export default function App() {
  return (
    <AppProvider>
      <Routes>
        <Route path="/" element={<AppShell />}>
          <Route path="files" element={<FilesPage />} />
          <Route path="files/starred" element={<FilesPage />} />
          <Route path="files/trash" element={<FilesPage />} />
          <Route path="files/folder/:folderId" element={<FilesPage />} /> 
          <Route path="drive" element={<DrivePage />} />
          <Route path="studio" element={<StudioPage />} />
          <Route path="calendar" element={<CalendarPage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="groups" element={<GroupsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="account" element={<AccountPage />} />
        </Route>
        <Route index element={<LoginPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route path="verify-email" element={<VerifyEmailPage />} />
        <Route path="confirm-email-change" element={<ConfirmEmailChangePage />} />
      </Routes>
    </AppProvider>
  );
}